import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FiInfo } from "react-icons/fi";
import React from "react";

const ToolTip = ({ keyValue, message, placement, className }) => {
  return (
    <OverlayTrigger
      key={keyValue}
      placement={placement}
      overlay={
        <Tooltip id={`${keyValue}-tooltip`} className={keyValue}>
          {message}
        </Tooltip>
      }
      delayShow={300}
      delayHide={150}
    >
      <span className={`tooltip-icon ${className}`}>
        <FiInfo className={"warning"} />
      </span>
    </OverlayTrigger>
  );
};

export default ToolTip;
